import { Component } from '@angular/core';

import { HomePage } from '../home/home';
import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
import { AppDescribtionPage } from '../AppDescribtion/AppDescribtion';
import { SettingPage } from '../Setting/Setting';
import { NoteficationPage } from '../Notefication/Notefication';
import { LoginPage } from '../Login/Login';
import { SessionProvider } from '../../providers/SessionProvider';
import { NavController } from 'ionic-angular';

@Component({
    templateUrl: 'tabs.html'
})
export class TabsPage {
    // this tells the tabs component which Pages
    // should be each tab's root Page
    tab1Root: any = HomePage;
    tab2Root: any = AppDescribtionPage;
    tab3Root: any = SettingPage;
    tab4Root: any = NoteficationPage;
    constructor(public sessionProvider: SessionProvider, public navctrl: NavController) {
    }
    Logout() {
        //this.navctrl.push(LoginPage);
        console.log("LoginPage");
    }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts